import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { ivimsAdapter } from './ivimsReducers';
import { getTopologyType } from '_store/application/hooks';
import { TopologyType } from '_store/application/types';

const ivimStateDomain = (state: RootState) => state.ivims;

export const ivimsSelector = createSelector(ivimStateDomain, (ivim) =>
  ivimsAdapter.getSelectors().selectAll(ivim),
);

export const totalIvimsSelector = createSelector(ivimStateDomain, (ivim) => ivim.total);

export const ivimFilterStatusSelector = createSelector(
  ivimStateDomain,
  (ivim) => ivim.statusFilter,
);

export const ivimFilterDateSelector = createSelector(ivimStateDomain, (ivim) => ivim.dateFilter);

export const ivimFilterUpdatedFromSelector = createSelector(
  ivimStateDomain,
  (ivim) => ivim.updatedFromFilter,
);

export const ivimFilterUpdatedToSelector = createSelector(
  ivimStateDomain,
  (ivim) => ivim.updatedToFilter,
);

export const ivimsSelectorForSelectedRoadSegment = (roadSegmentIds: string[]) =>
  createSelector(ivimsSelector, (ivim) => {
    const topologyType = getTopologyType();

    if (topologyType === TopologyType.URBAN) {
      return ivim;
    }

    return ivim.filter((d) => roadSegmentIds.includes(d.roadSegmentId));
  });

export const paginationCurrentPageSelector = createSelector(
  ivimStateDomain,
  (ivim) => ivim.paginationCurrentPage,
);

export const paginationItemsPerPageSelector = createSelector(
  ivimStateDomain,
  (ivim) => ivim.paginationItemsPerPage,
);

export const ivimFilterServiceCategoryCodeSelector = createSelector(
  ivimStateDomain,
  (ivim) => ivim.serviceCategoryCodeFilter,
);

export const ivimFilterServiceSubCategoryCodeSelector = createSelector(
  ivimStateDomain,
  (ivim) => ivim.serviceSubCategoryCodeFilter,
);

export const ivimFilterSourceSelector = createSelector(
  ivimStateDomain,
  (ivim) => ivim.sourceFilter,
);

export const ivimsAllData = createSelector(ivimStateDomain, (ivim) => ivim.allData || []);

export const loadingCSVSelector = createSelector(ivimStateDomain, (ivim) => ivim.loadingCSV);
